module.exports = __webpack_public_path__ + "static/media/reduce-commissions.b2725adf.svg";